export const BUY_URL = 'https://borgui.com/buy'
